import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const prev = document.title;
        document.title = "Admin | Purposeful, Inc.";
        let robots = document.querySelector('meta[name="robots"]');
        const originalRobots = robots ? robots.getAttribute("content") : null;
        if (!robots) {
            robots = document.createElement("meta");
            robots.setAttribute("name", "robots");
            document.head.appendChild(robots);
        }
        robots.setAttribute("content", "noindex, nofollow");
        return () => {
            document.title = prev;
            if (originalRobots !== null) robots.setAttribute("content", originalRobots);
        };
    }, []);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password);
            toast.success("Welcome back.");
            navigate("/admin");
        } catch (err) {
            const m = err?.response?.data?.detail;
            toast.error(typeof m === "string" ? m : "Login failed.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <main data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-6 fingerprint-bg">
            <form onSubmit={submit} className="w-full max-w-md card-dark p-10" data-testid="admin-login-form">
                <Lock size={20} className="text-[#D4AF37]" />
                <h1 className="font-display text-3xl mt-4 font-semibold">Admin login</h1>
                <p className="text-zinc-500 mt-2 text-sm">Manage Substack posts, the directory and the waitlist.</p>

                <div className="mt-8 space-y-4">
                    <input
                        type="email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email"
                        data-testid="admin-email-input"
                        className="w-full rounded-lg bg-white/5 border border-white/10 px-4 py-3 text-sm focus:outline-none focus:border-[#D4AF37] transition"
                    />
                    <input
                        type="password"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                        data-testid="admin-password-input"
                        className="w-full rounded-lg bg-white/5 border border-white/10 px-4 py-3 text-sm focus:outline-none focus:border-[#D4AF37] transition"
                    />
                    <button type="submit" disabled={loading} data-testid="admin-login-submit" className="btn-gold w-full disabled:opacity-60">
                        {loading ? <Loader2 size={16} className="animate-spin" /> : "Sign in"}
                    </button>
                </div>
            </form>
        </main>
    );
}
